import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=2ac3c0c8&scoped=true&"
import script from "./EditContact.vue?vue&type=script&lang=ts&"
export * from "./EditContact.vue?vue&type=script&lang=ts&"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=2ac3c0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3c0c8",
  null
  
)

export default component.exports